var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('NavBar'),_c('v-main',{attrs:{"id":"mainFrame"}},[_c('router-view',{key:_vm.$route.path})],1),_c('v-footer',{attrs:{"id":"footer"}},[_c('the-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }